import { VacationPayReport } from "../../../components/Reports/VacationPayReport";
import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";


export const VacationPayReportPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Vacation Pay"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
      ]}
      mainContents={<VacationPayReport/>}
    />
  );
};
